import React, { useContext, useEffect } from "react";

import { Row, Col, Card, Button, ListGroup } from "@themesberg/react-bootstrap";
import { faChartLine, faChevronRight, faInfo, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { UserContext } from "../../../utils/ProtectedRoute";
import { CounterWidget } from "../../../components/widgets";
import { useDispatch, useSelector } from "react-redux";

import { GetAllSurveyUser, reset as resetSurvey } from "../../../features/SurveySlice";
import { Link } from "react-router-dom";
import { GetAllMadingActive, reset as resetMading } from './../../../features/mading/MadingSlice';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Dashboard = () => {
  const { userData } = useContext(UserContext);

  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const { data: dataSurvey, isLoading: isLoadingSurvey } = useSelector((state) => state.survey);
  const { data: dataMading, isLoading: isLoadingMading } = useSelector((state) => state.mading);

  useEffect(() => {
    dispatch(resetSurvey());
    dispatch(resetMading());
    dispatch(GetAllSurveyUser({ token }));
    dispatch(GetAllMadingActive({ token }));
  }, []);

  const AdminView = () => (
    <Row className="justify-content-md-center">
      {/** <Col xs={12} sm={12} xl={8} className="mb-4">
        <Card>
          <Card.Header>
            <Card.Title>Grafik</Card.Title>
          </Card.Header>
          <Card.Body>
            <Chart type="Line" options={optionLine} data={dataLine} />
          </Card.Body>
        </Card>
      </Col> **/}
      <Col xs={12} className="mb-4">
        <Card>
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5>Mading</h5>
              </Col>
              {/* <Col className="text-end">
                <Button variant="secondary" size="sm">
                  See all
                </Button>
              </Col> */}
            </Row>
          </Card.Header>

          <Card.Body>
            <MadingView
              data={dataMading?.items || []}
            />
          </Card.Body>
          {/* <Table responsive className="align-items-center table-flush">
            <thead className="thead-light">
              <tr>
                <th scope="col">Infomasi</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="col">Pembaruan VA pembayaran</th>
                <th scope="col">
                  <Button variant="secondary" size="sm">
                    Lihat
                  </Button>
                </th>
              </tr>
            </tbody>
          </Table> */}
        </Card>
      </Col>

      {/* <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col>
      <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col>
      <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col> */}
    </Row>
  );

  const MahasiswaView = () => (
    <Row className="justify-content-md-center">
      {(dataSurvey?.data || [])?.length > 0 ? (
        <Col xs={12} className="mb-4">
          <Card>
            <Card.Header>
              <Row className="align-items-center">
                <Col>
                  <h5>Isi Survey!</h5>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <ListGroup>
                {dataSurvey?.data?.map((item, i) => (
                  <ListGroup.Item
                    key={i}
                    variant="info"
                    action
                    as={Link}
                    to={`/survey/answer/${item.id}`}
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">{item.nama}</div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      ) : null}

      <Col xs={12} className="mb-4">
        <Card>
          <Card.Header>
            <Row className="align-items-center">
              <Col>
                <h5>Mading</h5>
              </Col>
              {/* <Col className="text-end">
                <Button variant="secondary" size="sm">
                  See all
                </Button>
              </Col> */}
            </Row>
          </Card.Header>
          <Card.Body>
            <MadingView
              data={dataMading?.items || []}
            />
          </Card.Body>
        </Card>
      </Col>

      {/* <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col>
      <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col>
      <Col xs={12} sm={6} xl={4} className="mb-4">
        <CounterWidget
          category="Customers"
          title="345k"
          period="Feb 1 - Apr 1"
          percentage={18.2}
          icon={faChartLine}
          iconColor="shape-secondary"
        />
      </Col> */}
    </Row>
  );

  const MadingView = ({data}) => {
    return data ? (
      <ListGroup>
        {data?.map((item, i) => (
          <ListGroup.Item
            key={i}
            variant="info"
            action
            as={Link}
            to={`/mading/view/${item.slug}`}
            className="d-flex justify-content-between align-items-start"
          >
            <div className="ms-2 me-auto">
              <div className="fw-bold"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{item.title}</div>
            </div>
            <FontAwesomeIcon icon={faChevronRight} className="mt-1" />
          </ListGroup.Item>
        ))}
      </ListGroup>
    ) :
    "Belum ada data!";
  }

  return (
    <AdminLayout>
      <h1>Hai, {userData?.nama}</h1>
      <p>
        Selamat datang di Sistem Informasi Layanan Administrasi dan Keuangan
        Fakultas Teknik Universitas Dr. Soetomo
      </p>
      {userData?.id_role !== "HA05" ? <AdminView /> : <MahasiswaView />}
    </AdminLayout>
  );
};

export default Dashboard;
